export default {
    data: () => ({
        translations: {
            createAccount: {
                el: "Δημιουργία Λογαριασμού",
                en: "Create Account",
                it: "Crea account"
            },
            country: {
                el: "Χώρα",
                en: "Country",
                it: "Paese"
            },
            
            mobile: {
                el: "Κινητό τηλέφωνο",
                en: "Mobile Phone",
                it: "Telefono cellulare"
            },
            iAcceptThe: {
                el: "Αποδέχομαι τους",
                en: "I accept the",
                it: "Accetto"
            },
            iAccept: {
                el: "Αποδέχομαι",
                en: "I accept",
                it: "Accetto"
            },
            terms: {
                el: "'Ορους υπηρεσιών'",
                en: "Terms of Services",
                it: "Termini di servizio"
            },
            and: {
                el: "και την",
                en: "and",
                it: "e"
            },
            policy: {
                el: "Πολιτική απορρήτου",
                en: "Privacy Policy",
                it: "Informativa sulla privacy"
            },
            alreadyAccount: {
                el: "Έχετε ήδη λογαριασμό?",
                en: "Already have an account?",
                it: "Avete già un account?"
            },
            signIn: {
                el: "Συνδεθείτε",
                en: "Sign In",
                it: "Accedi"
            },
            here: {
                el: "εδώ",
                en: "here",
                it: "qui"
            },
            register: {
                el: "εγγραφη",
                en: "register",
                it: "registro"
            },
            directMarketing: {
                el: "Άμεσο μάρκετινγκ",
                en: "Direct Marketing",
                it: "Marketing diretto"
            },
            fullName: {
                el: "Ονοματεπώνυμο",
                en: "Full Name",
                it: "Nome completo"
            },
            password: {
                el: "Κωδικός πρόσβασης",
                en: "Password",
                it: "Password"
            },
            confirmPassword: {
                el: "Επιβεβαίωση κωδικού πρόσβασης",
                en: "Confirm Password",
                it: "Conferma la password"
            },
            birthDate: {
                el: "Ημερομηνία γέννησης",
                en: "Birth Date",
                it: "Data di nascita"
            },
            referral: {
                el: "Παραπομπή",
                en: "Referral",
                it: "Referral"
            },
            save: {
                el: "Αποθηκευση",
                en: "Save",
                it: "Risparmiare"
            },
            userInfo: {
                el: "Πληροφορίες χρήστη",
                en: "User Information",
                it: "Informazioni sull'utente"
            },
            enderMobileCode: {
                el: "Εισάγετε Κωδικό Επιβεβαίωσης",
                en: "Enter Confirmation Code",
                it: "Inserire il Codice di Conferma"
            },
            confirmationDescription: {
                el: "Έχουμε στείλει έναν 4ψήφιο κωδικό στον αριθμό κινητού που καταχωρήσατε",
                en: "We have sent a 4 digit code to mobile number you entered",
                it: "Abbiamo inviato un codice di 4 cifre al numero di cellulare che avete inserito"
            },
            mobileCode: {
                el: "Κωδικός Επιβεβαίωσης",
                en: "Confirmation Code",
                it: "Codice di Conferma"
            },
            notReceived: {
                el: "Δεν λάβατε τον κωδικό;",
                en: "Didn't receive code?",
                it: "Non avete ricevuto il codice?"
            },
            resend: {
                el: "Επαναποστολή",
                en: "Resend",
                it: "Reinvio"
            },
            verify: {
                el: "επαληθευση",
                en: "verify",
                it: "verificare"
            },
        }
    })
};
